import React, { useEffect, useState } from 'react';
import {
  getLocalReservationConfigurationByLocalId,
} from '../../../../crud/management_api/reservations_configuration';
import ReservationsTable from './components/ReservationsTable/ReservationsTable';
import DaySchedule       from './components/DaySchedule/DaySchedule';
import ReservationConfiguration from './components/ReservationConfiguration/ReservationConfiguration';
import ReservationStack  from './components/ReservationStack/ReservationStack';
import LoadingSpinner    from '../../../../components/common/LoadingSpinner';
import {
  ReservationConfiguration as RC,
  ReservationResponse    as RP,
} from './types';
import { useNotifications } from '../../../Base/components/NavBar/components/HeaderProfile/components/NotificationCenter/NotificationContext';
import { LocalSession } from '../../../../types/LocalSession';
import { MPPageTitle } from '../../../../components/ui';

interface ReservationManagementProps {
  lastSession?: LocalSession | null;
}

const ReservationManagement: React.FC<ReservationManagementProps> = ({ lastSession }) => {
  const [selectedView, setSelectedView] = useState<'list' | 'config' | 'day' | 'hist'>('hist');
  const [reservationConfiguration, setReservationConfiguration] = useState<RC | null>(null);
  const [loading, setLoading] = useState(true);
  const { reservations, setReservations } = useNotifications();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const user   = JSON.parse(localStorage.getItem('user') || '{}');
      const localId = user?.local_id ?? 0;
      try {
        const res = await getLocalReservationConfigurationByLocalId(localId);
        const rp: RP = res.data;
        const rc: RC = {
          local_id:      rp.local_id,
          configuration: rp.object,
          last_modified: rp.timestamp,
        };
        setReservationConfiguration(rc);
      } catch (err) {
        console.error('Failed to load reservation config:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const renderToggle = () => (
    <div className="mp-button-selector-page-container">
      <div className="mp-button-selector-page-selector">
        <button
          onClick={() => setSelectedView('hist')}
          className={`mp-button-selector-page-button ${selectedView === 'hist' ? 'active' : 'inactive'}`}
        >
          Historial
        </button>
        <button
          onClick={() => setSelectedView('config')}
          className={`mp-button-selector-page-button ${selectedView === 'config' ? 'active' : 'inactive'}`}
        >
          Configuración
        </button>
      </div>
    </div>
  );

  if (loading) {
    return <LoadingSpinner text="Cargando Configuración" transparent />;
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Reservaciones</MPPageTitle>
      {renderToggle()}

      {selectedView === 'hist' && <ReservationsTable lastSession={lastSession} />}

      {selectedView === 'day' && (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <DaySchedule />
        </div>
      )}

      {selectedView === 'list' && <ReservationStack lastSession={lastSession} />}

      {selectedView === 'config' && reservationConfiguration && (
        <ReservationConfiguration
          data={reservationConfiguration}
          setData={setReservationConfiguration as React.Dispatch<React.SetStateAction<RC>>}
        />
      )}
    </div>
  );
};

export default ReservationManagement;
